import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { colors } from '../constants/colors';

export function ReadyToBidBanner() {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);
  const [fetched, setFetched] = useState(false);

  // Fetch fresh user data if hasAddress/hasPaymentMethod are unknown
  useEffect(() => {
    if (user && user.hasAddress === null && user.hasPaymentMethod === null && !fetched) {
      setFetched(true);
      refreshUser().catch(() => {});
    }
  }, [user, fetched, refreshUser]);

  if (dismissed) return null;
  if (!user) return null;
  if (!user.phoneVerified || !user.emailVerified) return null;
  // Hide while we're still fetching the flags
  if (user.hasAddress === null || user.hasPaymentMethod === null) return null;
  if (user.hasAddress && user.hasPaymentMethod) return null;

  return (
    <div style={styles.banner}>
      <div style={styles.header}>
        <span style={styles.title}>Ready to bid?</span>
        <button onClick={() => setDismissed(true)} style={styles.closeButton}>
          &times;
        </button>
      </div>
      <p style={styles.description}>
        Add your address and payment method to start bidding on live auctions.
      </p>
      <div style={styles.actions}>
        {!user.hasAddress && (
          <button onClick={() => navigate('/addresses')} style={styles.actionButton}>
            Add Address
          </button>
        )}
        {!user.hasPaymentMethod && (
          <button onClick={() => navigate('/payment-methods')} style={styles.actionButton}>
            Add Payment
          </button>
        )}
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  banner: {
    backgroundColor: colors.brand.blue15,
    border: `1px solid ${colors.brand.blue20}`,
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '16px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
  },
  title: {
    fontSize: '16px',
    fontWeight: '600',
    color: colors.ink.black,
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '20px',
    color: colors.gray[400],
    cursor: 'pointer',
    padding: '0 4px',
  },
  description: {
    fontSize: '14px',
    color: colors.gray[600],
    marginBottom: '12px',
  },
  actions: {
    display: 'flex',
    gap: '8px',
  },
  actionButton: {
    padding: '8px 16px',
    backgroundColor: colors.white,
    border: `1px solid ${colors.gray[300]}`,
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    color: colors.brand.blue,
    cursor: 'pointer',
  },
};
